import React from "react";
import { TextArea } from "semantic-ui-react";
import classNames from "classnames";

export default function TextAreaControl({
  name,
  onFocus,
  onBlur,
  onChange,
  value,
  autoHeight,
  className,
  readOnly,
  ...rest
}) {
  return (
    <TextArea
      className={classNames(className, { "TextAreaControl--autoHeight": autoHeight })}
      name={name}
      value={value === null ? "" : value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange && ((event) => onChange(event.target.value))}
      autoHeight={autoHeight}
      {...rest}
    />
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/TextArea.jsx